import React from 'react'
import { useParams } from 'react-router-dom'
import "./notfound.scss"
const NotFound = () => {
    const {pageName} = useParams()
  return (
    <>
    <h1>404 Error Page</h1>
    <p class="zoom-area"><b>{pageName}</b> </p>
    <section class="error-container">
      <span>4</span>
      <span><span class="screen-reader-text">0</span></span>
      <span>4</span>
    </section>
    </>
  )
}

export default NotFound